import { render } from "./AgencyCampaignsNew.vue?vue&type=template&id=61556530&scoped=true"
import script from "./AgencyCampaignsNew.vue?vue&type=script&lang=js"
export * from "./AgencyCampaignsNew.vue?vue&type=script&lang=js"

import "./AgencyCampaignsNew.vue?vue&type=style&index=0&id=61556530&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61556530"]])

export default __exports__